"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return _Tooltip.Tooltip;
  }
});
var _Tooltip = require("./Tooltip");
function cov_1h0bdg7klo() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Tooltip/index.ts";
  var hash = "dca5ef3fda79c0d7a7ad0362c413c377606fdbae";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Tooltip/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dca5ef3fda79c0d7a7ad0362c413c377606fdbae"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1h0bdg7klo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1h0bdg7klo();